import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/ui';
import ButtonCore from 'components/ButtonCore';
import VisuallyHidden from 'components/VisuallyHidden';
var ButtonWrapper = styled(ButtonCore).withConfig({
  displayName: "RowSelectButton__ButtonWrapper",
  componentId: "sc-1x74tu4-0"
})(["position:absolute;left:0;top:0;bottom:0;width:", ";background-color:", ";opacity:0;&:focus{outline:none;}tr[aria-selected='true'] &&{opacity:1;}tr[data-highlighted] &&[data-focus-visible-added]{opacity:1;}"], pxToRem(4), function (p) {
  return p.theme.links;
});
var RowSelectButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ButtonWrapper, _extends({
    ref: ref
  }, otherProps), /*#__PURE__*/React.createElement(VisuallyHidden, null, children));
});
RowSelectButton.displayName = 'RowSelectButton';
export default RowSelectButton;